/**
 * --------------------------------------------------------------------------
 * NJ : CollapseSearchBar.js
 * --------------------------------------------------------------------------
 */

import Collapse, { CLASS_NAME as COLLAPSE_CLASS_NAME, DATA_KEY as COLLAPSE_DATA_KEY } from './Collapse';
import { Data, EventHandler, Manipulator, Testing } from 'nj-utils';
import AbstractFormBase from './AbstractFormBase';
import Config from './config';
import { coreConfig } from 'nj-components/core.config';


/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'collapseSearchBar';
const DATA_KEY = `${coreConfig.KEY_PREFIX}.${NAME}`;

const SELECTOR = {
  default: '.nj-navbar__search',
  anyInput: 'input, select, textarea',
  target: 'data-target'
};

const DEFAULT_CONFIG = {
  njFormGroup: {
    required: false
  }
};

class CollapseSearchBar extends AbstractFormBase {
  constructor(element, config) {
    super(CollapseSearchBar, element, Manipulator.extend(true, DEFAULT_CONFIG, config));
    this.element = element;

    if (this.element && !Collapse.getInstance(element)) {
      Data.setData(element, DATA_KEY, this);
    }

    this.triggerElement = document.querySelector(`[data-toggle="collapse"][${SELECTOR.target}="#${element.id}"]`) ||
      document.querySelector(`[data-toggle="collapse"][href="#${element.id}"]`);

    const closedElement = document.querySelector(`[data-dismiss="#${element.id}"]`);
    if (closedElement) {
      this.closedElement = closedElement;
      this.closedElement.addEventListener('click', this.dismissHandler.bind(this));
    }

    Testing.assert(
      element,
      this.triggerElement.length === 0,
      `Cannot find collapse trigger for ${Testing.describe(element)}`
    );

    Testing.assert(
      element,
      !this.element.classList.contains(COLLAPSE_CLASS_NAME.collapse),
      `${Testing.describe(
        element
      )} is expected to have the '${COLLAPSE_CLASS_NAME.collapse}' class.  It is being targeted by ${Testing.describe(
        element
      )}`
    );

    // find the first input for focusing if exist
    const inputs = this.element.querySelectorAll(SELECTOR.anyInput);
    if (inputs.length > 0) {
      this.input = inputs[0];
    }

    if (this.input) {
      // add a listener to set focus
      EventHandler.on(this.element, `${Config.shownEvent}.${COLLAPSE_DATA_KEY}`, () => {
        this.input.focus();
      });

      // add a listener to collapse field
      EventHandler.on(this.input, 'blur', (event) => {
        this.dismissHandler(event);
      });
    }
  }

  dispose() {
    Data.removeData(this.element, DATA_KEY);
    this.element = null;
  }

  static init(options) {
    return super.init(this, options, SELECTOR.default);
  }

  static getInstance(element) {
    const data = Data.getData(element, DATA_KEY);

    return data ? data : Collapse.getInstance(element);
  }

  dismissHandler(event) {
    event.preventDefault();
    if (event.target.closest(`[data-dismiss="#${this.element.id}"]`) || event.target.closest(`[href="#${this.element.id}"]`)) {
      EventHandler.trigger(this.triggerElement, 'click');
    }
  }

  // Static
  static selector = SELECTOR.default;
}

export default CollapseSearchBar;
